"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Carousel = _interopRequireDefault(require("../../darkmatter/Carousel"));

var _IndicatorGroup = _interopRequireDefault(require("./components/IndicatorGroup"));

require("./ImageBanner.css");

var ImageBanner = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ImageBanner, _React$Component);

  function ImageBanner() {
    (0, _classCallCheck2["default"])(this, ImageBanner);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ImageBanner).apply(this, arguments));
  }

  (0, _createClass2["default"])(ImageBanner, [{
    key: "getOverlayClassNames",
    value: function getOverlayClassNames() {
      var overlay = this.props.overlay;
      if (overlay === 'primary') return 'overlay-primary';
      if (overlay === 'dark') return 'overlay-dark';
      if (overlay === 'light') return 'overlay-light';
      return '';
    }
  }, {
    key: "renderImage",
    value: function renderImage(image) {
      var indicatorGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _this$props = this.props,
          backgroundSize = _this$props.backgroundSize,
          height = _this$props.height,
          header = _this$props.header,
          tagline = _this$props.tagline,
          callToAction = _this$props.callToAction,
          parallax = _this$props.parallax;
      var imageStyle = {
        backgroundAttachment: parallax && 'fixed',
        backgroundImage: "url('".concat(image, "')"),
        backgroundSize: backgroundSize,
        height: height,
        backgroundPosition: 'center'
      };
      var overlayStyle = {
        width: '100%',
        height: '100%'
      };
      var overlayClassNames = this.getOverlayClassNames();
      return _react["default"].createElement("div", {
        className: "image-banner",
        style: imageStyle
      }, _react["default"].createElement(_semanticUiReact.Grid, {
        className: "image-banner-animation ".concat(overlayClassNames),
        style: overlayStyle,
        verticalAlign: "middle",
        textAlign: "center"
      }, _react["default"].createElement(_semanticUiReact.Grid.Column, null, header, tagline, callToAction, indicatorGroup)));
    }
  }, {
    key: "renderBanner",
    value: function renderBanner() {
      var backgroundImage = this.props.backgroundImage;
      return this.renderImage(backgroundImage);
    }
  }, {
    key: "renderGallery",
    value: function renderGallery() {
      var _this = this;

      var _this$props2 = this.props,
          galleryImages = _this$props2.galleryImages,
          carouselOptions = _this$props2.carouselOptions;
      var autoScroll = carouselOptions.autoScroll,
          autoScrollTime = carouselOptions.autoScrollTime;
      var indicatorStyle = {
        textAlign: 'center',
        position: 'absolute',
        bottom: '1em',
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 200
      };
      return _react["default"].createElement(_Carousel["default"], {
        totalNumberOfItems: galleryImages.length,
        autoScroll: autoScroll,
        autoScrollTime: autoScrollTime,
        numberOfDisplayItems: 1
      }, function (_ref) {
        var currentIndex = _ref.currentIndex,
            changeCurrentIndex = _ref.changeCurrentIndex;
        return _react["default"].createElement("div", {
          style: {
            position: 'relative'
          }
        }, _this.renderImage(galleryImages[currentIndex]), _react["default"].createElement("div", {
          style: indicatorStyle
        }, _react["default"].createElement(_IndicatorGroup["default"], {
          images: galleryImages,
          currentIndex: currentIndex,
          changeCurrentIndex: changeCurrentIndex
        })));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var as = this.props.as;
      return as === 'banner' ? this.renderBanner() : this.renderGallery();
    }
  }]);
  return ImageBanner;
}(_react["default"].Component);

exports["default"] = ImageBanner;
ImageBanner.propTypes = {
  as: _propTypes["default"].oneOf(['banner', 'carousel']),
  backgroundImage: _propTypes["default"].string,
  backgroundSize: _propTypes["default"].oneOf(['cover', 'contain']),
  callToAction: _propTypes["default"].element,
  carouselOptions: _propTypes["default"].shape({
    autoScroll: _propTypes["default"].bool,
    autoScrollTime: _propTypes["default"].number
  }),
  galleryImages: _propTypes["default"].arrayOf(_propTypes["default"].string),
  header: _propTypes["default"].element,
  height: _propTypes["default"].number,
  overlay: _propTypes["default"].oneOf(['dark', 'light', 'primary', 'none']),
  parallax: _propTypes["default"].bool,
  tagline: _propTypes["default"].element
};
ImageBanner.defaultProps = {
  as: 'banner',
  backgroundImage: '',
  backgroundSize: 'cover',
  callToAction: null,
  carouselOptions: {
    autoScroll: undefined,
    autoScrollTime: undefined
  },
  galleryImages: [],
  header: null,
  height: 500,
  overlay: 'none',
  parallax: false,
  tagline: null
};